import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase-config';
import { VendorConfig } from '../types/VendorConfigTypes';

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  configToDelete: VendorConfig | null;
  onDeleteSuccess: () => void;
}

function DeleteConfirmationModal({
  open,
  onClose,
  configToDelete,
  onDeleteSuccess,
}: DeleteConfirmationModalProps) {
  const handleDeleteConfirm = async () => {
    if (!configToDelete?.id) return;

    try {
      await deleteDoc(doc(db, 'vendorConfigs', configToDelete.id));
      enqueueSnackbar('Vendor configuration deleted successfully', { variant: 'success' });
      onDeleteSuccess();
    } catch (error) {
      console.error('Error deleting vendor config:', error);
      enqueueSnackbar('Error deleting vendor configuration', { variant: 'error' });
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete the vendor configuration for &quot;
          {configToDelete?.vendorName}
          &quot;?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleDeleteConfirm}
          variant="contained"
          color="error"
          sx={{
            backgroundColor: 'var(--westland-red)',
            '&:hover': {
              backgroundColor: 'var(--westland-red-darker)',
            },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationModal;
